export default __webpack_public_path__ + "static/media/vpi.789a363f.svg";